import Menu from 'components/commons/menu'
import { Header } from 'components/header'
import { MENU } from 'constants/constant'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useFetch } from '../../services/useFetch'
import { API } from '../../services/api'
import { FooterSidebar } from './FooterSidebar'
import { HeaderSidebar } from './HeaderSidebar'
import { useDispatch, useSelector } from 'react-redux'
import { setActivatedCompany } from '../../reducers/companiesReducer'
import CONFIG from 'configs/env'
import { Alert } from 'components/commons/alert'

export const Layout = ({ children }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const [sidebarList, setSidebarList] = useState([])
    const [companies, setCompanies] = useState([])
    const [profile, setProfile] = useState()
    const [modules, setModules] = useState([])
    const [hasCompanySetting, setCompanySetting] = useState(false)
    const { activatedCompany } = useSelector((state) => state.companiesReducer)
    const { fetching: switchCompany } = useFetch(API.SWITCH_COMPANY, {})
    const { fetching: getMenuApi } = useFetch(API.LIST_MENU)

    useEffect(() => {
        handleGetMenu()
    }, [])

    const handleGetMenu = () => {
        getMenuApi()
            .then((resp) => {
                let menu = resp?.data?.menus
                let displayMenu = []
                MENU.map((item) =>
                    menu.map((i) => {
                        if (i.slug === item.slug) {
                            const newItem = {
                                ...item,
                                child: i.child,
                            }
                            displayMenu.push(newItem)
                        }
                    }),
                )

                if (!activatedCompany) {
                    dispatch(setActivatedCompany(resp?.data?.companies.find((company) => company.selected === true)))
                }
                const findCompanySetting = menu.find((item) => item.slug === 'company-settings')
                setCompanySetting(findCompanySetting)

                setSidebarList(displayMenu)
                setModules(resp?.data?.modules)
                setCompanies(resp?.data?.companies)
                setProfile(resp?.data?.profile)
            })
            .catch((err) => console.log('err'))
    }

    const onNavigate = (e) => {
        navigate(e)
    }

    const onClickLogout = () => {
        Alert({
            icon: 'warning',
            message: 'Are you sure you want to logout?',
            messageClassName: 'text-base font-medium text-center',
            buttonContainer: 'justify-center!',
            buttonConfirmText: 'Logout',
            buttonCloseText: 'Cancel',
        }).then((isConfirm) => {
            if (isConfirm) window.location.href = `${CONFIG.API_ENDPOINT}${API.LOGOUT.api}`
        })
    }

    const onSwitchCompany = (company) => {
        switchCompany({}, company?.id)
            .then(() => {
                dispatch(setActivatedCompany(company))
                handleGetMenu()
                navigate('/', { replace: true })
            })
            .catch((err) => console.log('err'))
    }

    return (
        <div className='flex'>
            <Menu
                className='!bg-neutral-10/50 h-screen w-[220px] sticky top-0 z-20'
                items={sidebarList}
                selectedKey={location.pathname.substring(1)}
                onClick={onNavigate}
                contentHeader={
                    <HeaderSidebar
                        companies={companies}
                        activeCompany={activatedCompany}
                        onSwitchCompany={onSwitchCompany}
                    />
                }
                contentFooter={(isCollapse) => (
                    <FooterSidebar modules={modules} isCollapse={isCollapse} hasCompanySetting={hasCompanySetting} />
                )}
            />

            <div className={'flex-1 overflow-y-auto'}>
                <Header
                    userProfile={profile}
                    breadcrumbPath={location.pathname}
                    onNavigate={onNavigate}
                    onClickLogout={onClickLogout}
                />
                {children}
            </div>
        </div>
    )
}
